import { api, unwrap, toPaginated, cleanParams } from "../lib/axios";
import type { ApiEnvelope, ListParams, PaginatedResult } from "../types/api";
import type { Admin, AdminRole } from "../types/admin";

export interface CreateAdminBody {
  name: string;
  email: string;
  phoneNumber: string;
  password: string;
  role: AdminRole;
}

export type UpdateAdminBody = Partial<Omit<CreateAdminBody, "password">>;

export const adminsApi = {
  async list(params: ListParams): Promise<PaginatedResult<Admin>> {
    const res = await api.get<ApiEnvelope<unknown>>("/admin", {
      params: cleanParams(params),
    });
    return toPaginated<Admin>(res, "admins");
  },

  async create(body: CreateAdminBody): Promise<Admin> {
    const res = await api.post<ApiEnvelope<{ admin: Admin }>>("/admin", body);
    const data = unwrap(res);
    // create returns { admin, tokens }
    return (data.admin ?? (data as unknown as Admin)) as Admin;
  },

  async update(id: string, body: UpdateAdminBody): Promise<Admin> {
    const res = await api.patch<ApiEnvelope<{ admin: Admin } | Admin>>(
      `/admin/${id}`,
      body,
    );
    const data = unwrap(res) as { admin?: Admin } & Admin;
    return data.admin ?? data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/admin/${id}`);
  },
};
